export default "__VITE_ASSET__kI_lFjJL__"